import { useContext, useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { getAdGroup } from "../services/AuthorizationService/AuthorizationService";

import { AuthConsumer, AuthContext } from "../providers/AuthProvider";
import LoadingSpinner from "../components/Spinner/spinner";
import NotAuthorized from "../components/NotAuthorized/notAuthorized";
import { AuthorizationModel } from "../Model/AuthorizationModel";

const GuardedRoute = () => {
  const [adGroup, setADGroup] = useState<string | AuthorizationModel>("");
  const { getAccessToken } = useContext(AuthContext);

  useEffect(() => {
    // declare the data fetching function
    const fetchData = async () => {
      try {
        const result = await getAdGroup(getAccessToken());
        setADGroup(result);
        console.log("adgroup is " + result);
      } catch (e: any) {
        setADGroup("not authorized");;
        console.log("error " + e);
      }
    };

    // call the function
    fetchData()
      // make sure to catch any error
      .catch(console.error);
  },[]);

  return (
    <AuthConsumer>
      {({ isAuthorized }) => {
        if (adGroup === null || adGroup === undefined || adGroup === "") {
          return <span><LoadingSpinner /></span>
        }
        if (typeof adGroup !== 'string' && isAuthorized(adGroup)) {
          console.log("adgroup is " + adGroup);
          return <Outlet />
        }
        else {
          console.log("not authorized");
          return <NotAuthorized />
        }
      }}
    </AuthConsumer>     
  )
}

export default GuardedRoute;